/**
 * Configuration for resume info. Provides information
 * on resume fields and mapping between API names and drupal naming structure.
 */
const jobiqoResumesConfig = require('./../src/jobiqo/config/resume');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const applicantsActive = true;
const resumeActive = true;

module.exports = mergeDeepRight(jobiqoResumesConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    RESUME_FEATURE_ACTIVE: resumeActive,
    APPLICANT_FEATURE_ACTIVE: applicantsActive,
    RESUME_SEARCHES_FEATURE_ACTIVE: false,
    RESUME_CONTACT_FEATURE_ACTIVE: false,
    RESUME_IMPORT_FEATURE_ACTIVE: false,
    GEO_INFO: {
      radius: {
        defaultValue: 5,
      },
      fixtures: [
        {
          label: 'Neubrandenburg, Deutschland',
          location: { lat: 53.5678292, lng: 13.2779269 },
        },
        {
          label: 'Prenzlau, Deutschland',
          location: { lat: 53.3173433, lng: 13.8633409 },
        },
        {
          label: 'Neustrelitz, Deutschland',
          location: { lat: 53.3601147, lng: 13.0730197 },
        },
        {
          label: 'Templin, Deutschland',
          location: { lat: 53.1168874, lng: 13.4979688 },
        },
        {
          label: 'Anklam, Deutschland',
          location: { lat: 53.8502906, lng: 13.6959731 },
        },
        {
          label: 'Waren (Müritz), Deutschland',
          location: { lat: 53.5161667, lng: 12.6818562 },
        },
      ],
    },
  },
});
